interface TopBannerProps {
  visible: boolean;
  onClose: () => void;
}

export default function TopBanner({ visible, onClose }: TopBannerProps) {
  if (!visible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-[#C9A96E] text-white text-center py-2.5 px-12 text-sm font-light tracking-wide">
      <span className="font-medium">오픈 기념 특별 할인 중!</span> 최대 60% OFF — 지금이 가장 저렴한 가격이에요
      <button
        onClick={onClose}
        className="absolute right-4 top-1/2 -translate-y-1/2 text-white/80 hover:text-white transition-colors cursor-pointer"
        aria-label="닫기"
      >
        <i className="ri-close-line text-lg"></i>
      </button>
    </div>
  );
}
